<!--RADIO-->
<ng-container *ngIf="inputType === 'radio'">
    <div *ngFor="let choice of questionChoices; let i = index" class="radio-container">
        <input
            [type]="inputType"
            [id]="inputId + i"
            [name]="inputId"
            [value]="choice.value"
            (change)="onSelectedRadio(choice.value)"
            [formControl]="radioControl"
            [checked]="value === choice.value"
        />

        <label [for]="inputId + i" [innerHtml]="choice.label | translate"></label>
        <a *ngIf="choice.linkLabel" class="blue-link" href="" (click)="choice.actionLink()">{{ choice.linkLabel | translate }}</a>
        <div class="sub-label" *ngIf="choice?.subLabel">{{ choice?.subLabel }}</div>
    </div>
</ng-container>

<!--CHECKBOX-->
<ng-container *ngIf="inputType === 'checkbox'">
    <div *ngFor="let choice of questionChoices; let i = index" class="form-control">
        <label class="checkbox-group" [for]="inputId + i">
            <span [innerHtml]="choice.label | translate"></span>
            <a *ngIf="choice.linkLabel" class="blue-link" href="" (click)="choice.actionLink()">{{ choice.linkLabel | translate }}</a>
            <input
                [type]="inputType"
                [id]="inputId + i"
                [name]="inputId"
                [value]="choice.value"
                (change)="onSelectedCheckbox(choice.value)"
                [formControl]="radioControl"
                [checked]="isArray(value) ? value?.includes(choice.value) : value === choice.value"
            />
            <span class="checkmark"></span>
        </label>
    </div>
</ng-container>
